<template>
  <!-- 更新日志区域 -->
  <section id="changelog">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="changelog-header-box">
            <div class="box-info">
              <h2>39游戏盒子</h2>
              <p>您的游戏库和随身礼包助手</p>
              <p>提供官方资讯、社区交友、周边商城、云手机等功能</p>
              <a class="download-btn" href="https://bbsnewapi.3975bbs.com/common/packageAppLink?advertisingId=351" target="_blank">下载最新版本</a>
            </div>
          </div>
          <div class="changelog-header">
            <div class="changelog-tabs">
              <div class="changelog-tab" :class="{ 'active': activePlatform === 'android' }" @click="switchPlatform('android')">
                安卓端更新
              </div>
              <div class="changelog-tab" :class="{ 'active': activePlatform === 'ios' }" @click="switchPlatform('ios')">
                苹果端更新
              </div>
            </div>
          </div>

          <div class="changelog-timeline">
            <div v-for="(yearGroup, yearIndex) in changelogsByYear" :key="yearGroup.year" class="changelog-year-group">
              <!-- 年份标题 - 只在非当前年份时显示 -->
              <div v-if="yearGroup.year != new Date().getFullYear()" class="changelog-year-title  changelog-item"><div  class="changelog-date">{{ yearGroup.year }}</div>
                <div class="changelog-content"></div>
              </div>

              <!-- 该年份的版本列表 -->
              <div v-for="(item, itemIndex) in yearGroup.items" :key="`${yearGroup.year}-${itemIndex}`" class="changelog-item" :class="{ 'active': yearIndex === 0 && itemIndex === 0 }">
                <div class="changelog-date">{{ formatDate(item.update_date) }}</div>
                <div class="changelog-content">
                  <div class="changelog-version">版本：{{ item.version }}</div>
                  <ul class="changelog-list">
                    <li v-html="item.content">
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div class="changelog-footer">
            <button class="btn btn-outline-light" @click="loadMoreVersions" v-if="hasMoreData">
              查看更多版本
            </button>
            <div class="no-more-data" v-if="!hasMoreData" style="font-size: .7rem; text-align: center; color: #ccc; margin-top: 1rem;">
              暂无更多
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ChangelogSection',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activePlatform: 'android',
      noMoreData: false,
      pageSize: 10, // 每页显示的记录数
      currentPage: {
        android: 1,
        ios: 1
      },
      allData: {
        android: [],
        ios: []
      },
      androidChangelogs: [
      ],
      iosChangelogs: [
      ]
    }
  },
  computed: {
    currentChangelogs() {
      const platform = this.activePlatform;
      const allData = this.allData[platform].length > 0 ? this.allData[platform] : this[platform + 'Changelogs'];
      const currentPage = this.currentPage[platform];
      const endIndex = currentPage * this.pageSize;
      return allData.slice(0, endIndex);
    },
    // 按年份分组的版本数据
    changelogsByYear() {
      const platform = this.activePlatform;
      const allData = this.allData[platform].length > 0 ? this.allData[platform] : this[platform + 'Changelogs'];
      const currentPage = this.currentPage[platform];
      const endIndex = currentPage * this.pageSize;
      const currentData = allData.slice(0, endIndex);

      // 按年份分组
      const groupedByYear = {};
      currentData.forEach(item => {
        const year = this.getYearFromDate(item.update_date);
        if (!groupedByYear[year]) {
          groupedByYear[year] = [];
        }
        groupedByYear[year].push(item);
      });

      // 转换为数组并按年份降序排列
      return Object.keys(groupedByYear)
        .sort((a, b) => b - a)
        .map(year => ({
          year: year,
          items: groupedByYear[year]
        }));
    },
    hasMoreData() {
      const platform = this.activePlatform;
      const allData = this.allData[platform].length > 0 ? this.allData[platform] : this[platform + 'Changelogs'];
      const currentPage = this.currentPage[platform];
      return allData.length > currentPage * this.pageSize;
    }
  },
  mounted() {
    // 初始化分页状态
    this.currentPage.android = 1;
    this.currentPage.ios = 1;

    this.getVersion('android');
    this.getVersion('ios');
  },
  methods: {
    getVersion(platform) {
      this.$ajax('/common/versionLog', {
        platform
      }).then(rs => {
        if (rs.code == 200) {
          this.allData[platform] = rs.data;
          this[platform + 'Changelogs'] = rs.data;
          // 初始化当前页为1，只显示前10条
          this.currentPage[platform] = 1;
        }
      }).catch(error => {
        console.log('API调用失败:', error);
        // API失败时使用默认数据，也要初始化分页
        this.currentPage[platform] = 1;
      });
    },
    switchPlatform(platform) {
      this.activePlatform = platform;
      // 切换平台时重置当前页为1
      this.currentPage[platform] = 1;
    },
    loadMoreVersions() {
      const platform = this.activePlatform;
      this.currentPage[platform] += 1;
    },
    handleDownload() {
      this.$emit('download');
    },
    // 格式化日期
    formatDate(dateString) {
      if (!dateString || dateString === '0000-00-00 00:00:00') {
        return new Date().toLocaleDateString('zh-CN', { month: '2-digit', day: '2-digit' }).replace('/', '-');
      }

      const date = new Date(dateString);
      return date.toLocaleDateString('zh-CN', { month: '2-digit', day: '2-digit' }).replace('/', '-');
    },
    // 从日期字符串中获取年份
    getYearFromDate(dateString) {
      if (!dateString || dateString === '0000-00-00 00:00:00') {
        return new Date().getFullYear();
      }
      const date = new Date(dateString);
      return date.getFullYear();
    },
  }
}
</script>

<style lang="scss" scoped>
.changelog-year-title {
  display: flex;
  justify-content: center;
  margin-top: .5rem;
  .changelog-content {
    height: 1px !important;
    padding: 0 !important;
    margin-top: 1.5rem;
    background: #707070 !important;
  }
}
.changelog-year-group{
  .changelog-item{
    &:last-child{
      margin-bottom: 0;
    }
  }
}
</style>